import React from 'react';
import styled from 'styled-components';

const DocsPage = styled.div`
  max-width: 800px;
  margin: 0 auto;
  
  h1 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 2.5rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 1rem;
    line-height: 1.2;
  }
  
  h2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.8rem;
    font-weight: 600;
    color: #ffffff;
    margin: 2rem 0 1rem 0;
    line-height: 1.3;
  }
  
  h3 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.4rem;
    font-weight: 600;
    color: #ffffff;
    margin: 1.5rem 0 0.75rem 0;
    line-height: 1.4;
  }
  
  p {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.6;
    color: #e5e7eb;
    margin-bottom: 1rem;
  }
  
  ul, ol {
    margin: 1rem 0;
    padding-left: 1.5rem;
  }
  
  li {
    font-family: 'Roboto', sans-serif;
    font-size: 1rem;
    line-height: 1.6;
    color: #e5e7eb;
    margin-bottom: 0.5rem;
  }
  
  code {
    font-family: 'monospace', sans-serif;
    background: rgba(0, 0, 0, 0.3);
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 0.9em;
    color: #a855f7;
  }
  
  .contract-info {
    background: rgba(16, 185, 129, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .contract-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #10b981;
    margin-bottom: 1rem;
  }
  
  .contract-address {
    font-family: 'monospace', sans-serif;
    font-size: 0.9rem;
    color: #ffffff;
    background: rgba(0, 0, 0, 0.3);
    padding: 0.75rem;
    border-radius: 8px;
    margin: 0.75rem 0;
    word-break: break-all;
  }
  
  .feature-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
    margin: 2rem 0;
  }
  
  .feature-card {
    background: rgba(168, 85, 247, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
  }
  
  .feature-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #a855f7;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .step {
    background: rgba(168, 85, 247, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 1.5rem 0;
  }
  
  .step-number {
    background: #a855f7;
    color: #ffffff;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }
  
  .step-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #ffffff;
    margin-bottom: 0.75rem;
  }
  
  .step-content {
    font-family: 'Inter', sans-serif;
    color: #e5e7eb;
    line-height: 1.6;
  }
  
  .info-box {
    background: rgba(59, 130, 246, 0.1);
    border-radius: 8px;
    padding: 1rem;
    margin: 1rem 0;
  }
  
  .info-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: #3b82f6;
    margin-bottom: 0.5rem;
  }
  
  .info-text {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 0.95rem;
  }
  
  .warning-box {
    background: rgba(245, 158, 11, 0.1);
    border-radius: 8px;
    padding: 1rem;
    margin: 1rem 0;
  }
  
  .warning-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: #f59e0b;
    margin-bottom: 0.5rem;
  }
  
  .warning-text {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 0.95rem;
  }
  
  .fee-distribution {
    background: rgba(16, 185, 129, 0.1);
    border-radius: 12px;
    padding: 1.5rem;
    margin: 2rem 0;
  }
  
  .fee-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.2rem;
    font-weight: 600;
    color: #10b981;
    margin-bottom: 1rem;
  }
  
  .fee-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 1rem;
    margin-top: 1rem;
  }
  
  .fee-item {
    background: rgba(16, 185, 129, 0.05);
    border-radius: 8px;
    padding: 1rem;
    text-align: center;
  }
  
  .fee-percentage {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #10b981;
    margin-bottom: 0.5rem;
  }
  
  .fee-label {
    font-family: 'Inter', sans-serif;
    color: #d1d5db;
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
  
  @media (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }
    
    h2 {
      font-size: 1.5rem;
    }
    
    .feature-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const MavrkLocker: React.FC = () => {
  return (
    <DocsPage>
      <h1>Mavrk Locker</h1>
      
      <p>
        The Mavrk Locker is a critical security infrastructure component that ensures permanent liquidity and enables transparent fee distribution for all tokens deployed on the Mavrk platform. Every liquidity position NFT is automatically and permanently locked at the moment of token creation.
      </p>

      <div className="contract-info">
        <div className="contract-title">Contract Information</div>
        <p><strong>Contract Address:</strong></p>
        <div className="contract-address">0x0f417FaB5b78aaCC265137Ebd83b41c44f515d3F</div>
        <p><strong>Network:</strong> Ink L2 (Chain ID: 57073)</p>
        <p><strong>Purpose:</strong> Permanent LP locking and fee distribution</p>
        <p><strong>Explorer:</strong> <a href="https://explorer.inkonchain.com/address/0x0f417FaB5b78aaCC265137Ebd83b41c44f515d3F" target="_blank" rel="noopener noreferrer" style={{ color: '#60a5fa' }}>View on Explorer</a></p>
      </div>

      <h2>What is the Mavrk Locker?</h2>

      <p>
        The Mavrk Locker is a specialized smart contract designed to permanently secure liquidity positions created through the Mavrk Token Factory. Unlike traditional token lockers that allow withdrawal after a time period, the Mavrk Locker <strong>permanently locks liquidity position NFTs</strong> to ensure:
      </p>

      <div className="feature-grid">
        <div className="feature-card">
          <h3 className="feature-title">🔒 Permanent Security</h3>
          <ul>
            <li>Liquidity cannot be removed by anyone</li>
            <li>No time-based unlock mechanism</li>
            <li>Immutable protection against rug pulls</li>
            <li>Complete transparency on blockchain</li>
          </ul>
        </div>

        <div className="feature-card">
          <h3 className="feature-title">💰 Fee Distribution</h3>
          <ul>
            <li>Fee collection from LP trading</li>
            <li>25% distributed to token creators</li>
            <li>75% allocated to platform operations</li>
            <li>Transparent on-chain distribution</li>
          </ul>
        </div>

        <div className="feature-card">
          <h3 className="feature-title">⚡ Atomic Integration</h3>
          <ul>
            <li>LP NFT transferred instantly at deployment</li>
            <li>Part of token creation transaction flow</li>
            <li>No additional user action required</li>
            <li>Gas-efficient single transaction</li>
          </ul>
        </div>
      </div>

      <h2>Atomic Transaction Flow</h2>

      <p>
        The Mavrk Token Factory contract is designed with an <strong>atomic transaction flow</strong> that ensures liquidity is permanently secured at the moment of token creation. This happens in a single, indivisible blockchain transaction:
      </p>

      <div className="step">
        <div className="step-number">1</div>
        <div>
          <h3 className="step-title">Token Deployment</h3>
          <div className="step-content">
            <p>The MavrkTokenFactory contract deploys a new ERC-20 token with:</p>
            <ul>
              <li><strong>Total Supply:</strong> 1,000,000,000 tokens (1 billion)</li>
              <li><strong>Decimals:</strong> 18 (standard ERC-20)</li>
              <li><strong>ERC-2771 Support:</strong> Gasless transaction compatibility</li>
              <li><strong>Optimized Design:</strong> Minimal bytecode for efficiency</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="step">
        <div className="step-number">2</div>
        <div>
          <h3 className="step-title">Liquidity Pool Creation</h3>
          <div className="step-content">
            <p>Immediately following token deployment, the factory contract:</p>
            <ul>
              <li><strong>Pairs 100% of token supply</strong> with WETH in a Reservoir/Relay Protocol (Uniswap V3) or Velodrome V3 pool</li>
              <li><strong>Creates concentrated liquidity</strong> position for optimal capital efficiency</li>
              <li><strong>Generates LP NFT</strong> representing the entire liquidity position</li>
              <li><strong>Sets optimal price range</strong> for trading efficiency</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="step">
        <div className="step-number">3</div>
        <div>
          <h3 className="step-title">Automatic LP NFT Locking</h3>
          <div className="step-content">
            <p>As part of the same atomic transaction, the LP NFT is:</p>
            <ul>
              <li><strong>Automatically transferred</strong> to the Mavrk Locker contract</li>
              <li><strong>Permanently locked</strong> with no withdrawal mechanism</li>
              <li><strong>Registered</strong> for fee collection capabilities</li>
              <li><strong>Associated</strong> with the token creator's address for earnings</li>
            </ul>
            <div className="info-box">
              <div className="info-title">Atomic Execution</div>
              <div className="info-text">
                All three steps occur in a single blockchain transaction. If any step fails, the entire transaction reverts, ensuring no tokens can be deployed without permanently locked liquidity.
              </div>
            </div>
          </div>
        </div>
      </div>

      <h2>Fee Distribution System</h2>

      <div className="fee-distribution">
        <h3 className="fee-title">LP Trading Fee Collection</h3>
        <p>
          Reservoir/Relay Protocol (Uniswap V3) or Velodrome V3 liquidity pools generate trading fees from every swap that occurs. For Mavrk-deployed tokens, these fees are collected and distributed through the Mavrk Locker contract:
        </p>

        <h3>Fee Structure</h3>
        <div className="fee-grid">
          <div className="fee-item">
            <div className="fee-percentage">1%</div>
            <div className="fee-label">Reservoir/Relay Protocol (Uniswap V3) or Velodrome V3 LP Fee</div>
            <p style={{ fontSize: '0.85rem', marginTop: '0.5rem', color: '#9ca3af' }}>
              Standard V3 fee tier for all Mavrk token pools
            </p>
          </div>
        </div>

        <h3 style={{ marginTop: '1.5rem' }}>Distribution Split</h3>
        <div className="fee-grid">
          <div className="fee-item">
            <div className="fee-percentage">25%</div>
            <div className="fee-label">Creator Earnings</div>
            <p style={{ fontSize: '0.85rem', marginTop: '0.5rem', color: '#9ca3af' }}>
              Distributed to the original token creator
            </p>
          </div>
          <div className="fee-item">
            <div className="fee-percentage">75%</div>
            <div className="fee-label">Platform Operations</div>
            <p style={{ fontSize: '0.85rem', marginTop: '0.5rem', color: '#9ca3af' }}>
              Supports platform development and sustainability
            </p>
          </div>
        </div>
      </div>

      <h2>Whitelisted Fee Collection</h2>

      <p>
        The Mavrk Locker implements a <strong>permissioned fee collection system</strong> to ensure security and proper distribution:
      </p>

      <div className="feature-grid">
        <div className="feature-card">
          <h3 className="feature-title">👤 Token Creators</h3>
          <p>
            Each token creator is automatically whitelisted to collect their 25% share of trading fees through the Platform interface:
          </p>
          <ul>
            <li>Navigate to the <strong>Profile</strong> section on the website</li>
            <li>View accumulated earnings in the <strong>Creator Earnings</strong> section</li>
            <li>Click the <strong>"Collect"</strong> button to claim fees</li>
            <li>Confirm the transaction in your wallet</li>
            <li>Fees are transferred directly to your wallet</li>
            <li>Track earnings in real-time with USD values</li>
          </ul>
        </div>

        <div className="feature-card">
          <h3 className="feature-title">🏢 Platform Wallet</h3>
          <p>
            A dedicated whitelisted wallet collects the 75% platform allocation:
          </p>
          <ul>
            <li>Authorized to call <code>collectFees</code> function</li>
            <li>Receives platform's share of trading fees</li>
            <li>Funds platform operations and development</li>
            <li>Transparent on-chain transactions</li>
          </ul>
        </div>
      </div>

      <h3>Fee Collection Process</h3>

      <div className="step">
        <div className="step-number">1</div>
        <div>
          <h3 className="step-title">Trading Activity</h3>
          <div className="step-content">
            <p>As users trade tokens on Reservoir/Relay Protocol (Uniswap V3) or Velodrome V3:</p>
            <ul>
              <li>Each swap generates a 1% fee</li>
              <li>Fees accumulate in the liquidity position</li>
              <li>Both token and WETH fees are collected</li>
              <li>Fees compound automatically</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="step">
        <div className="step-number">2</div>
        <div>
          <h3 className="step-title">Collecting Fees via Profile Section</h3>
          <div className="step-content">
            <p>Token creators collect their earnings through the user-friendly Platform interface:</p>
            <ul>
              <li><strong>Navigate to Profile:</strong> Go to the Profile section on the website</li>
              <li><strong>View Earnings:</strong> See accumulated fees in the Creator Earnings section</li>
              <li><strong>Click "Collect":</strong> Click the Collect button next to your earnings</li>
              <li><strong>Confirm Transaction:</strong> Sign the transaction in your wallet</li>
              <li><strong>Receive Fees:</strong> Your 25% share is transferred directly to your wallet</li>
            </ul>
            <div className="info-box">
              <div className="info-title">Simplified Process</div>
              <div className="info-text">
                The Platform handles all the technical smart contract interactions behind the scenes. Creators simply click "Collect" and sign the transaction - no need to interact with the blockchain explorer or call contract functions manually.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="step">
        <div className="step-number">3</div>
        <div>
          <h3 className="step-title">Fee Distribution</h3>
          <div className="step-content">
            <p>The Mavrk Locker distributes collected fees:</p>
            <ul>
              <li>Calculates proportional shares (25% / 75%)</li>
              <li>Transfers creator's share to their wallet</li>
              <li>Transfers platform's share to authorized wallet</li>
              <li>Emits events for transparency</li>
            </ul>
          </div>
        </div>
      </div>

      <h2>Security Features</h2>

      <div className="feature-grid">
        <div className="feature-card">
          <h3 className="feature-title">🔒 Immutable Locking</h3>
          <ul>
            <li><strong>No Withdrawal Function:</strong> LP NFTs cannot be removed</li>
            <li><strong>No Admin Override:</strong> Even contract admins cannot unlock</li>
            <li><strong>Permanent Security:</strong> Liquidity locked forever</li>
            <li><strong>Rug-Pull Prevention:</strong> Impossible to remove liquidity</li>
          </ul>
        </div>

        <div className="feature-card">
          <h3 className="feature-title">🛡️ Access Control</h3>
          <ul>
            <li><strong>Whitelisted Addresses:</strong> Only authorized fee collectors</li>
            <li><strong>Creator Rights:</strong> Each creator controls their earnings</li>
            <li><strong>Platform Rights:</strong> Single authorized platform wallet</li>
            <li><strong>No Manipulation:</strong> Cannot change fee distribution ratios</li>
          </ul>
        </div>

        <div className="feature-card">
          <h3 className="feature-title">📊 Transparency</h3>
          <ul>
            <li><strong>On-Chain Verification:</strong> All locks visible on explorer</li>
            <li><strong>Event Logging:</strong> All operations emit events</li>
            <li><strong>Public Queries:</strong> Anyone can verify lock status</li>
            <li><strong>Auditable:</strong> Complete transaction history</li>
          </ul>
        </div>
      </div>

      <h2>Benefits of Permanent Locking</h2>

      <div className="info-box">
        <div className="info-title">Why Permanent Locking?</div>
        <div className="info-text">
          <ul>
            <li><strong>Investor Confidence:</strong> Traders know liquidity cannot be removed</li>
            <li><strong>Price Stability:</strong> No risk of sudden liquidity withdrawal causing price crashes</li>
            <li><strong>Fair Trading:</strong> 100% of tokens must be bought on open market</li>
            <li><strong>Long-Term Viability:</strong> Tokens remain tradeable indefinitely</li>
            <li><strong>No Rug Pulls:</strong> Physically impossible to drain liquidity</li>
            <li><strong>Sustainable Earnings:</strong> Creators earn from organic trading activity</li>
          </ul>
        </div>
      </div>

      <h2>Key Differences from Traditional Lockers</h2>

      <div className="feature-grid">
        <div className="feature-card">
          <h3 className="feature-title">Traditional Token Lockers</h3>
          <ul>
            <li>Time-based locks (30, 90, 180 days, etc.)</li>
            <li>Liquidity can be withdrawn after expiry</li>
            <li>Optional renewal required</li>
            <li>Risk of non-renewal and liquidity removal</li>
            <li>No fee distribution mechanism</li>
          </ul>
        </div>

        <div className="feature-card">
          <h3 className="feature-title">Mavrk Locker</h3>
          <ul>
            <li><strong>Permanent locks</strong> - no expiry date</li>
            <li><strong>No withdrawal option</strong> - liquidity secured forever</li>
            <li><strong>No renewal needed</strong> - automatic permanence</li>
            <li><strong>Zero rug-pull risk</strong> - mathematically impossible</li>
            <li><strong>Built-in fee distribution</strong> - automatic creator earnings</li>
          </ul>
        </div>
      </div>

      <h2>Technical Implementation</h2>

      <h3>Smart Contract Functions</h3>

      <div className="step">
        <div className="step-number">1</div>
        <div>
          <h3 className="step-title">lockLPToken(uint256 tokenId, address creator)</h3>
          <div className="step-content">
            <p>Called automatically by MavrkTokenFactory during token deployment:</p>
            <ul>
              <li>Receives the LP NFT via <code>safeTransferFrom</code></li>
              <li>Records the position ID and creator address</li>
              <li>Establishes fee collection permissions</li>
              <li>Emits <code>LPTokenLocked</code> event</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="step">
        <div className="step-number">2</div>
        <div>
          <h3 className="step-title">collectFees(uint256 tokenId)</h3>
          <div className="step-content">
            <p>Called by whitelisted addresses (creator or platform) to collect fees:</p>
            <ul>
              <li>Verifies caller is authorized (creator or platform wallet)</li>
              <li>Calls Reservoir/Relay Protocol (Uniswap V3) or Velodrome V3 Position Manager's <code>collect</code> function</li>
              <li>Distributes 25% to creator, 75% to platform</li>
              <li>Emits <code>FeesCollected</code> and <code>FeesDistributed</code> events</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="step">
        <div className="step-number">3</div>
        <div>
          <h3 className="step-title">getLockInfo(uint256 tokenId)</h3>
          <div className="step-content">
            <p>Public view function for transparency:</p>
            <ul>
              <li>Returns creator address</li>
              <li>Returns lock timestamp</li>
              <li>Returns position details</li>
              <li>Provides accumulated fee information</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="warning-box">
        <div className="warning-title">Important Note</div>
        <div className="warning-text">
          The Mavrk Locker contract does NOT have any function to withdraw, unlock, or remove LP NFTs. This is by design to ensure permanent liquidity security. The ONLY operation possible is fee collection through the <code>collectFees</code> function.
        </div>
      </div>

      <h2>Verification and Transparency</h2>

      <p>
        Users can verify the permanent locking mechanism by:
      </p>

      <ul>
        <li><strong>Reviewing Contract Source Code:</strong> Verified on Ink L2 block explorer</li>
        <li><strong>Checking LP NFT Ownership:</strong> All LP NFTs owned by Mavrk Locker address</li>
        <li><strong>Monitoring Lock Events:</strong> <code>LPTokenLocked</code> events on-chain</li>
        <li><strong>Tracking Fee Collections:</strong> <code>FeesCollected</code> and <code>FeesDistributed</code> events</li>
        <li><strong>Verifying Position Status:</strong> Query Uniswap V3 Position Manager</li>
      </ul>

      <div className="info-box">
        <div className="info-title">Pro Tip</div>
        <div className="info-text">
          The Mavrk Locker's permanent locking mechanism is one of the key innovations that sets Mavrk apart from traditional token launchpads. By ensuring liquidity can never be removed, we create a trustless environment where every token deployed has guaranteed, permanent trading liquidity.
        </div>
      </div>
    </DocsPage>
  );
};

export default MavrkLocker;
